/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Irrigation_Schedule_Weekdays_RequiredInputs */

const vi_error_irrigation_schedule_weekdays_required = /** @type {(inputs: Error_Irrigation_Schedule_Weekdays_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn ít nhất một ngày áp dụng`)
};

/**

* @param {Error_Irrigation_Schedule_Weekdays_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_irrigation_schedule_weekdays_required = /** @type {((inputs?: Error_Irrigation_Schedule_Weekdays_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Irrigation_Schedule_Weekdays_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_irrigation_schedule_weekdays_required(inputs)
});